import React from "react";
import MatrixRow from "./MatrixRow";
import tableStyles from "../styles/tableStyles";

/**
 * MatrixTable
 *
 * Pure presentational component — owns NO state.
 * Renders the beat × month matrix using native <table> elements.
 *
 * Props:
 *  - matrixData            {Array}    List of beat rows (each with beatListData)
 *  - yearNameList          {Array}    List of month objects [{ name, ... }]
 *  - onTextFieldDataChange {Function} Curried: (monthName, beatId) => (event) => void
 */
const MatrixTable = ({ matrixData, yearNameList, onTextFieldDataChange }) => {
    if (!matrixData.length) return null;

    return (
        <div style={{ overflowX: "auto", width: "100%" }}>
            <table style={tableStyles.table}>
                <thead>
                    <tr>
                        <th style={{ ...tableStyles.th, minWidth: 50 }}>Sr. No</th>
                        <th style={{ ...tableStyles.th, minWidth: 160 }}>Beat Name</th>
                        {yearNameList.map((monthData) => (
                            <th key={monthData.name} style={tableStyles.th}>
                                {monthData.name}
                            </th>
                        ))}
                        <th style={{ ...tableStyles.th, minWidth: 100 }}>Total Target</th>
                    </tr>
                </thead>

                <tbody>
                    {matrixData.map((row, index) => (
                        <MatrixRow
                            key={row.id}
                            row={row}
                            index={index + 1}
                            onTextFieldDataChange={onTextFieldDataChange}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default MatrixTable;
